import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BucketService {
  private readonly queryEndpoint = `${environment.api}/bucket-query`;

  constructor(private http: HttpClient) {}

  getFile(path: string) {
    let params = new HttpParams().set('path', path);
    return this.http.get<Blob>(`${this.queryEndpoint}/api/v1/file`, {
      params: params,
      responseType: 'blob' as any,
    });
  }
}
